var React = require('react');

function IconList (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M961.2 143H65.1v128h896.1V143zm-1 321H65.1v128h895.1V464zm0 319H65.1v128h895.1V783z"}));
}

IconList.displayName = "IconList";

IconList.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconList;

IconList.default = IconList;
